import { AxiosResponse } from 'axios';
import { ClassType, transformAndValidate } from 'class-transformer-validator';

export const conformObjectResponse = async <T extends { [key: string]: any }>(request: Promise<AxiosResponse<T>>, dtoModel: ClassType<T>) => {
    const { data: unsafe_data } = await request;
    if (!unsafe_data) {
        throw new Error('No Data');
    }
    return await transformAndValidate(dtoModel, unsafe_data);
};

export const conformArrayResponse = async <T extends object>(request: Promise<AxiosResponse<T[]>>, dtoModel: ClassType<T>) => {
    const { data: unsafe_data } = await request;
    return await Promise.all(unsafe_data.map(item => transformAndValidate(dtoModel, item)));
};
